import type { ReactNode } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

import type { AgentAuthorityError } from '@/lib/heyapi/types.gen';

interface AgentAuthorityErrorsContextProps {
  agentAuthorityErrors: AgentAuthorityError[];
  setAgentAuthorityErrors: (errors: AgentAuthorityError[]) => void;
}

export const AgentAuthorityErrorsContext =
  createContext<AgentAuthorityErrorsContextProps>({
    agentAuthorityErrors: [],
    setAgentAuthorityErrors: () => {},
  });

export const AgentAuthorityErrorsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [agentAuthorityErrors, setAgentAuthorityErrors] = useState<
    AgentAuthorityError[]
  >([]);

  const memoizedContextValues = useMemo(
    () => ({ agentAuthorityErrors, setAgentAuthorityErrors }),
    [agentAuthorityErrors, setAgentAuthorityErrors]
  );

  return (
    <AgentAuthorityErrorsContext.Provider value={memoizedContextValues}>
      {children}
    </AgentAuthorityErrorsContext.Provider>
  );
};

export const useAgentAuthorityErrors = () => {
  const context = useContext(AgentAuthorityErrorsContext);
  if (!context) {
    throw new Error(
      'useAgentAuthorityErrors must be used within a AgentAuthorityErrorsProvider'
    );
  }
  return context;
};
